import {
  loadFavorites,
  saveFavorites
} from "./chunk-5HLNXJ3G.mjs";
import {
  ActionType
} from "./chunk-SWO6SUCI.mjs";

// lib/components/search-panel/search-condition-panel/hooks/use-search-condition-favorite.ts
import { useCallback, useState } from "react";
var useSearchConditionFavorite = (storageKey, items, callback, disableFavorite) => {
  const [favorites, setFavorites] = useState(() => {
    if (disableFavorite) {
      return { items: [] };
    }
    const temp = loadFavorites(storageKey, items);
    const current = temp.items.find((v) => v.id === temp.currentId);
    if (current) {
      callback(ActionType.FavoriteLoaded, current.inputs);
    }
    return temp;
  });
  const saveFavorite = useCallback(
    (items2) => {
      const date = /* @__PURE__ */ new Date();
      const next = {
        ...favorites,
        items: [
          ...favorites.items,
          {
            id: `${date.getTime()}`,
            inputs: items2
          }
        ]
      };
      saveFavorites(storageKey, next);
      setFavorites(next);
    },
    [favorites, storageKey]
  );
  const removeFavorite = useCallback(
    (id) => {
      const next = {
        ...favorites,
        currentId: id === favorites.currentId ? void 0 : favorites.currentId,
        items: favorites.items.filter((v) => v.id !== id)
      };
      saveFavorites(storageKey, next);
      setFavorites(next);
    },
    [favorites, storageKey]
  );
  const setCurrent = useCallback(
    (id) => {
      const next = { ...favorites, currentId: id };
      saveFavorites(storageKey, next);
      setFavorites(next);
    },
    [favorites, storageKey]
  );
  const setDefault = useCallback(
    (id) => {
      const next = { ...favorites, currentId: id };
      saveFavorites(storageKey, next);
      setFavorites(next);
    },
    [favorites, storageKey]
  );
  if (disableFavorite) {
    return {
      favorites,
      saveFavorite: (_) => {
      },
      removeFavorite: (_) => {
      },
      setCurrent: (_) => {
      },
      setDefault: (_) => {
      }
    };
  }
  return { favorites, saveFavorite, removeFavorite, setCurrent, setDefault };
};

export {
  useSearchConditionFavorite
};
